import {
    apiCalculateSubscriptionEditOffersPrice,
    apiCalculateSubscriptionOffersPrice,
    SubscriptionOfferStore
} from "../../../../client/state/SubscriptionOfferStore.js";
import {iFrameMerchantService} from "../../../services/IframeMerchantService.js";
import {iFrameUserDataService} from "../../../services/IFrameUserDataService.js";
import {wrapInSpinner} from "../../../../core/ui/LoadingSpinner.jsx";
import {Router} from "../../../../stem-core/src/ui/Router.jsx";
import {SUBSCRIPTION_PLAN_PANEL_URL} from "../../PanelConstants.js";
import {BaseFlowStep} from "./BaseFlowStep.jsx";


export const SUBSCRIBE_PLAN_STATE = {
    subscribe: "subscribe",
    editSubscription: "editSubscription",
    giftSubscription: "giftSubscription",
};


export class SubscriptionPlanFlowStep extends BaseFlowStep {
    subscriptionPlanState = SUBSCRIBE_PLAN_STATE.subscribe; // TODO @flow2 this is not part of this class

    discountCode = null;
    applyPolicy = null;

    shareName = true; // TODO @flow2 handle as generic metadata

    // Internally used fields
    discountCodeMap = new Map();
    instantChangeDiscountCodeMap = new Map();
    pendingRequests = 0;

    get selectedOffer() {
        return this.selectedValue;
    }

    userHasEquivalentSubscriptionToOffer(subscriptionOffer) {
        const subscription = iFrameUserDataService.getActiveSubscription();
        if (!subscription) {
            return false;
        }
        if (!subscriptionOffer) {
            return true;
        }
        return subscription.billingPlan === subscriptionOffer.billingPlan && subscription.coverage === subscriptionOffer.coverage;
    }

    userHasEquivalentSubscriptionToSelected() {
        return this.selectedValue == null || this.userHasEquivalentSubscriptionToOffer(this.selectedValue);
    }

    async fetchSubscriptionEditPrices(address) {
        this.pendingRequests += 1;

        try {
            const {recurringOffers} = await apiCalculateSubscriptionEditOffersPrice({
                discountCode: this.discountCode,
                deliveryAddressId: address?.id,
                subscriptionId: iFrameUserDataService.getActiveSubscription().id,
            });
            this.instantChangeDiscountCodeMap.clear();
            this.discountCodeMap.clear();
            for (const info of recurringOffers) {
                const subscriptionOffer = info.recurringOfferId == null ? null : SubscriptionOfferStore.get(info.recurringOfferId);
                if (info.applyPolicy === "instantly") {
                    this.instantChangeDiscountCodeMap.set(subscriptionOffer, info);
                } else {
                    this.discountCodeMap.set(subscriptionOffer, info);
                }
            }
        } catch (error) {
            this.update({discountCode:  null});
        } finally {
            this.pendingRequests -= 1;
            if (!this.pendingRequests) {
                this.dispatch();
            }
        }
    }

    // TODO @cleanup debounce this
    async checkDiscountCode(address) {
        this.pendingRequests += 1;
        this.discountCodeMap.clear();
        try {
            const {recurringOffers} = await apiCalculateSubscriptionOffersPrice({
                discountCode: this.discountCode,
                merchantId: iFrameMerchantService.merchantId,
                deliveryAddressId: address?.id
            });
            for (const info of recurringOffers) {
                this.discountCodeMap.set(SubscriptionOfferStore.get(info.recurringOfferId), info);
            }
        } catch (error) {
            this.update({discountCode: null});
            // TODO: Handle API error.
        } finally {
            this.pendingRequests -= 1;
            if (!this.pendingRequests) {
                this.dispatch();
            }
        }
    }

    getDiscountInfo(offer) {
        return this.discountCodeMap.get(offer);
    }

    // Get price maybe with discount
    getSubscriptionOfferPrice(offer) {
        const discountInfo = this.getDiscountInfo(offer);
        if (discountInfo) {
            const {discountedBeforeTaxesPrice, discountValue} = discountInfo;
            return discountValue ? offer.formatPrice(discountedBeforeTaxesPrice) : offer.getPrice();
        }

         return offer.getPrice();
    }

    getDiscountInfoOnInstantChangePolicy(offer) {
        return this.instantChangeDiscountCodeMap.get(offer);
    }

    @wrapInSpinner
    async fetchPrices(address=null) {
        // TODO @flow2 why are these two methods so different?
        if (this.subscriptionPlanState === SUBSCRIBE_PLAN_STATE.editSubscription) {
            await this.fetchSubscriptionEditPrices(address);
        } else {
            await this.checkDiscountCode(address);
        }
    }

    showPanel() {
        Router.changeURL(SUBSCRIPTION_PLAN_PANEL_URL);
    }
}
